export default __webpack_public_path__ + "static/media/vision.c1c9a531.jpeg";